import { render } from "./SystemFilter.vue?vue&type=template&id=c836c07a"
import script from "./SystemFilter.vue?vue&type=script&lang=js"
export * from "./SystemFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__